// extracted by mini-css-extract-plugin
module.exports = {"container":"warning-banner_container__yFIJO"};